module.exports = __webpack_public_path__ + "img/running.9ed1cdf4.svg";